import * as Sentry from "@sentry/tanstackstart-react";
import type { Router } from "@tanstack/react-router";

export function initSentryClient(router: Router<any, any, any>) {
	if (typeof window === "undefined") return;

	const dsn = import.meta.env.VITE_SENTRY_DSN;
	if (!dsn) {
		console.warn(
			"VITE_SENTRY_DSN not configured, client error tracking disabled",
		);
		return;
	}

	Sentry.init({
		dsn,
		environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "local",
		release: import.meta.env.VITE_SENTRY_RELEASE,
		sendDefaultPii: true,
		integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
		tracesSampleRate: 0, // Glitchtip compatibility
	});
}

export { Sentry };
